/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAsDraftAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAsDraftAction({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/HtmlFile/Content/Content/Content/Actions/SaveAsDraftAction"
  
}) {
let editorIsDirtyValueData = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'isDirty',
})
let editorSavingValueData = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'saving',
})
let aggregateData = fromHelpers.disabled(editorIsDirtyValueData, editorSavingValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let editorSavingValueData1 = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'saving',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="primary"
 onClick={onClick}
 data="editor.isDirty"
 data="editor.saving"
 aggregate="./helpers.js disabled"
 disabled={aggregateData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={editorSavingValueData1 ? "Saving..." : "Save draft"}
 data="editor.saving"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}